import * as React from 'react';
import Box from '@mui/material/Box';
import Header from './Header';
import Body from './Body';
// import Footer from './Footer'; 


export default function Layout({ children }: React.PropsWithChildren) {
    return (
        <>
            <Box sx={{ display: 'flex' }}>
                <Header />

                <Body>
                    {children}
                </Body>
            </Box>
        </>
    );
}
